module.exports = __webpack_public_path__ + "img/s1.529b7ae6.jpg";